import {
  AppBar,
  Button,
  Toolbar,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import { CameraAlt } from "@material-ui/icons";
import React from "react";
import { clearLocalStorage } from "../../components/Utils/Utils";
import { scannerFormComplete } from "./parts/FormComplete";
import FormLogin from "./parts/FormLogin";
import { scannerFormPickup } from "./parts/FormPickup";
import pickup from "../../assets/icons/scanner-pickup.png";
import transaction from "../../assets/icons/scanner-transaction.png";
import "./style.css";

const useStyles = makeStyles((theme) =>
  createStyles({
    buttonLogout: {
      backgroundColor: "#F44336",
      color: "#FFFFFF",
      fontFamily: "Lato",
      fontSize: 13,
      borderRadius: 4,
      textTransform: "none",
    },
    buttonImg: {
      backgroundColor: "#FFFFFF",
      border: "1px solid #BDBDBD",
      borderRadius: 45,
      color: "#212121",
      width: 200,
      height: 200,
      textTransform: "none",
      lineHeight: "1.2",
    },
  })
);

const Scanner = () => {
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleOpenScanner = (action) => {
    if (action === "ready") {
      scannerFormPickup("Ready For Pickup").then(
        (onProcess) => {},
        (onCancel) => {}
      );
    } else if (action === "complete") {
      scannerFormComplete("Complete Transaction").then(
        (onProcess) => {},
        (onCancel) => {}
      );
    }
  };
  return (
    <div>
      {user && (
        <div>
          <AppBar position="static">
            <Toolbar></Toolbar>
          </AppBar>
          <div className="wrapper">
            <Button
              size="large"
              classes={{ root: classes.buttonImg }}
              onClick={() => handleOpenScanner("ready")}
              style={{ marginBottom: 12 }}
            >
              <div>
                <div style={{ marginBottom: 12 }}>
                  <img src={pickup} alt="scanner-pickup" />
                </div>
                Scan for
                <div>
                  <b> Ready for Pickup</b>
                </div>
              </div>
            </Button>
            <Button
              size="large"
              classes={{ root: classes.buttonImg }}
              onClick={() => handleOpenScanner("complete")}
              style={{ marginBottom: 12 }}
            >
              <div>
                <div style={{ marginBottom: 12 }}>
                  <img src={transaction} alt="scanner-pickup" />
                </div>
                Scan for
                <div>
                  <b> Complete Transaction</b>
                </div>
              </div>
            </Button>
            <Button
              variant="contained"
              classes={{ root: classes.buttonLogout }}
              onClick={clearLocalStorage}
            >
              LogOut
            </Button>
          </div>
        </div>
      )}

      {!user && <FormLogin />}
    </div>
  );
};

export default Scanner;
